import TagManager from 'react-gtm-module';

const GTM_ID = 'GTM-MZP5CQ';

export function initGTM(): void {
  TagManager.initialize({ gtmId: GTM_ID });
}

export function trackEvent(event: string, data?: Record<string, unknown>): void {
  TagManager.dataLayer({ dataLayer: { event, ...data } });
}

export function trackPageView(path: string): void {
  TagManager.dataLayer({
    dataLayer: {
      event: 'page_view',
      page_path: path,
      page_title: document.title,
    },
  });
}
